export const HAS_HOME_TILE_EXPERIMENT = true
